import CustomerViewer from "./CustomerViewer";
import { connect } from "react-redux";
import { getCustomerList } from "../../../../redux/actions/userManagement/customer.action";
import { getAllCustomerList } from "../../../../redux/actions/userManagement/getAllCustomerList.action";
import { ReadNotification } from "../../../../redux/actions/notification/getEventNotificationList.action";
import { getFilteredCustomers } from "../../../../redux/actions/userManagement/filterCustomers.action";
import { getUserReport } from "../../../../redux/actions/home/userReport.action";
// import { setColumnFilters } from "../../../../redux/actions/newService/service.actions";
import { resetColumnFilters, setColumnFilters, setStatusFilter } from "../../../../redux/actions/filters/filter.action";

const mapStateToProps = (state) => {
  return {
    list: state.customerList.list,
    next: state.customerList.next,
    isLoading: state.customerList.loading,
    statusCount:state?.customerList?.statusCount,
    myRights:state.myRights.myRights,
    allCustomerOption:state?.onboardingRequest?.getAllCustomerList.data,
    notificationdata:state?.notifications?.moduleNotification?.data?.data?.CUSTOMER_USERS,
    filterCustomers:state.onboardingRequest.filterCustomers.customers,
    userReport:state.userReport,
    columnFilters: state?.filtersReducer?.columnFilters?.CUSTOMER || {},
    activePrimaryTab :state.tabReducer.activePrimaryTab,
    statusFilter: state?.filtersReducer?.status?.CUSTOMER 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerList: (status = "", searchKey = "", next = "", uniqueCustomerRefId= "", /*orderBy = "",*/ serviceType="",sort="") => {
      return dispatch(getCustomerList(status, searchKey, next, uniqueCustomerRefId, /*orderBy,*/ serviceType,sort));
    },
    getAllCustomerList:() => {
      return dispatch(getAllCustomerList());
    },
    ReadNotification: (payload,id) => {
      return dispatch(ReadNotification(payload,id))
    },
    getFilteredCustomers: () => {
      return dispatch(getFilteredCustomers())
  },
  getUserReport: () => {
    return dispatch(getUserReport())
  },
    setColumnFilters: (screen, columnKey, options) =>{
        return dispatch(setColumnFilters(screen, columnKey, options))
    },
    setStatusFilter: (screen,data) => {
      return dispatch(setStatusFilter(screen, data))
    },
    resetColumnFilters: (screen) => {
      return dispatch(resetColumnFilters(screen))
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerViewer);
